"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const GalleryStore_1 = require("../stores/GalleryStore");
class EntitiesActions {
    static getGalleries(context, payload, callback) {
        context.service.read('works', {}, (err, searchResult) => {
            context.dispatch(GalleryStore_1.GALLERIES_RECEIVED, searchResult);
            callback();
        });
    }
    static getEntities(context, payload, callback) {
        context.service.read(payload.resource, {}, (err, result) => {
            if (err) {
                callback(err);
            }
            else {
                context.dispatch(payload.action, result);
                callback();
            }
        });
    }
    static sendEnquiry(context, payload, callback) {
        context.service.create('enquiry', {}, payload, callback);
    }
}
exports.default = EntitiesActions;
